angular.module("ainapp")
    .controller("addcompanyExpenseController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Company Expense";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Company Expense").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Company Expense").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
            $scope.ColumnWidth = null;
            MainService.TableDesignsbyVoucher("Company Expense").then(function (response) {
                if (response.data != null && response.data != "") {
                    $scope.TableDesign = response.data;
                    $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
                }
            });

            $scope.getExtramasters();

            $scope.VATs = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.VATs = response.data;
            });

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCompanyExpense(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data[0]);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }

            $scope.UpdateDetails = function (data) {

                $scope.CurrentCPV = data;
                $scope.CurrentCPV.Date = new Date($scope.CurrentCPV.Date);
                $scope.VoucherDocs = data.VoucherDocs;

                if ($scope.CurrentCPV.Field16 != null) {
                    $scope.CurrentCPV.Field16 = new Date($scope.CurrentCPV.Field16);
                }
                if ($scope.CurrentCPV.Field17 != null) {
                    $scope.CurrentCPV.Field17 = new Date($scope.CurrentCPV.Field17);
                }
                if ($scope.CurrentCPV.Field18 != null) {
                    $scope.CurrentCPV.Field18 = new Date($scope.CurrentCPV.Field18);
                }
                if ($scope.CurrentCPV.Field19 != null) {
                    $scope.CurrentCPV.Field19 = new Date($scope.CurrentCPV.Field19);
                }
                if ($scope.CurrentCPV.Field20 != null) {
                    $scope.CurrentCPV.Field20 = new Date($scope.CurrentCPV.Field20);
                }

                angular.forEach(data.CompanyExpenseCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })

                $scope.tempTotalQty = 0;
                $scope.tempUnitPrice = 0;
                $scope.tempGross = 0;
                $scope.tempDiscount = 0;
                $scope.tempVat = 0;

                angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {
                    $scope.tempTotalQty = $scope.tempTotalQty + e.Quantity;
                    $scope.tempUnitPrice = $scope.tempUnitPrice + e.UnitPrice;
                    $scope.tempGross = $scope.tempGross + e.Total;
                    $scope.tempDiscount = $scope.tempDiscount + e.Discount;
                    $scope.tempVat = $scope.tempVat + e.TaxValue;

                    if (e.Field16 != null) {
                        e.Field16 = new Date(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.Field17 = new Date(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.Field18 = new Date(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.Field19 = new Date(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.Field20 = new Date(e.Field20);
                    }

                    var costs = angular.copy($scope.CostCenters);
                    if (e.CompanyExpenseCosts.length > 0) {
                        angular.forEach(e.CompanyExpenseCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }

                });


                angular.forEach($scope.CurrentCPV.CompanyExpensePayments, function (e) {
                    e.Date = new Date(e.Date);
                    e.IsActive = true;
                });

                if (data.CompanyExpenseDetails.length <= 5) {

                    var temp2 = 5 - data.CompanyExpenseDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var CompanyExpenseDetails = {

                            Id: 0,
                            AccountId: "",
                            VATId: "",
                            Quantity: 0,
                            Amount: 0,
                            SubTotal: 0,
                            Taxable: 0,
                            TotalTAX: 0,
                            GrandTotal: 0,
                            Description: "",
                            VATType: "Exclusive",
                            Account: {},
                            CostCenters: angular.copy($scope.CostCenters),

                        }

                        $scope.CurrentCPV.CompanyExpenseDetails.push(CompanyExpenseDetails);
                    }
                }

                console.log($scope.CurrentCPV.VehicleCategoryId);
                if ($scope.CurrentCPV.VehicleCategoryId > 0) {
                    $scope.getVehicles();
                }
            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Company Expense').then(function (response) {
                $scope.VoucherSet = response.data;
            })

            $scope.Currencies = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencies = response.data;
            })


            $scope.generateDates = function () {

                var result = [];

                if ($scope.recurrenceSI.RecType == "Monthly") {

                    if ($scope.recurrenceSI.DayType == "Date Wise") {

                        var start = new Date($scope.recurrenceSI.FromDate);
                        var end = new Date($scope.recurrenceSI.ToDate);

                        while (start <= end) {
                            var year = start.getFullYear();
                            var month = start.getMonth();

                            // Ensure the day is valid for the month (e.g., handle February 30)
                            var date = new Date(year, month, $scope.recurrenceSI.Date);
                            if (date.getMonth() !== month) {
                                // If the day exceeds the max days in the month, set to last day
                                date = new Date(year, month + 1, 0);
                            }

                            if (date >= new Date($scope.recurrenceSI.FromDate) && date <= new Date($scope.recurrenceSI.ToDate)) {
                                result.push(date);
                            }

                            // Move to the next month
                            start.setMonth(start.getMonth() + 1);
                        }



                    }

                    if ($scope.recurrenceSI.DayType == "Day Wise" && $scope.recurrenceSI.DayOn == "First") {

                        var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                        var start = new Date($scope.recurrenceSI.FromDate);
                        var end = new Date($scope.recurrenceSI.ToDate);
                        var targetDay = daysOfWeek.indexOf($scope.recurrenceSI.Day);;

                        var count = 0;

                        while (start <= end) {
                            var year = start.getFullYear();
                            var month = start.getMonth();

                            // Ensure the day is valid for the month (e.g., handle February 30)
                            var firstDay = new Date(year, month, 1);
                            var firstTargetDay = new Date(year, month, 1 + ((targetDay - firstDay.getDay() + 7) % 7)); // Calculate first occurrence

                            if (firstTargetDay >= new Date($scope.recurrenceSI.FromDate) && firstTargetDay <= new Date($scope.recurrenceSI.ToDate)) {
                                if (count % $scope.recurrenceSI.Interval === 0) {
                                    result.push(firstTargetDay); // Format as YYYY-MM-DD
                                }
                                count++;
                            }

                            // Move to the next month
                            start.setMonth(start.getMonth() + 1);

                        }



                    }

                    if ($scope.recurrenceSI.DayType == "Day Wise" && $scope.recurrenceSI.DayOn == "Last") {

                        var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                        var start = new Date($scope.recurrenceSI.FromDate);
                        var end = new Date($scope.recurrenceSI.ToDate);
                        var targetDay = daysOfWeek.indexOf($scope.recurrenceSI.Day);;

                        var count = 0;

                        while (start <= end) {
                            var year = start.getFullYear();
                            var month = start.getMonth();

                            // Ensure the day is valid for the month (e.g., handle February 30)
                            var lastDayOfMonth = new Date(year, month + 1, 0);
                            var lastTargetDay = new Date(lastDayOfMonth);


                            while (lastTargetDay.getDay() !== targetDay) {
                                lastTargetDay.setDate(lastTargetDay.getDate() - 1);
                            }

                            if (lastTargetDay >= new Date($scope.recurrenceSI.FromDate) && lastTargetDay <= new Date($scope.recurrenceSI.ToDate)) {
                                if (count % $scope.recurrenceSI.Interval === 0) {
                                    result.push(lastTargetDay); // Format as YYYY-MM-DD
                                }
                                count++;
                            }


                            // Move to the next month
                            start.setMonth(start.getMonth() + 1);
                            start.setDate(1);

                        }



                    }

                }

                if ($scope.recurrenceSI.RecType == "Weekly") {

                    var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                    var start = new Date($scope.recurrenceSI.FromDate);
                    var end = new Date($scope.recurrenceSI.ToDate);
                    var targetDay = daysOfWeek.indexOf($scope.recurrenceSI.Day);;

                    while (start.getDay() !== targetDay) {
                        start.setDate(start.getDate() + 1);
                    }

                    var count = 0;
                    // Collect all occurrences of the target day within the date range
                    while (start <= end) {
                        if (count % $scope.recurrenceSI.Interval === 0) {
                            var temp = angular.copy(new Date(start));
                            result.push(temp);
                        }
                        count++;
                        start.setDate(start.getDate() + 7);
                    }



                }

                if ($scope.recurrenceSI.RecType == "Daily") {
                    var start = new Date($scope.recurrenceSI.FromDate);
                    var end = new Date($scope.recurrenceSI.ToDate);

                    while (start <= end) {
                        result.push(start); // Format as YYYY-MM-DD
                        start.setDate(start.getDate() + $scope.recurrenceSI.Interval); // Move forward by interval days
                    }


                }

                $scope.CurrentCPV.CompanyExpensePayments = [];

                angular.forEach(result, function (e) {

                    var temp = {
                        IsActive: true,
                        Date: e,
                    }
                    $scope.CurrentCPV.CompanyExpensePayments.push(temp);

                })

            }


            $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.Init = function () {

                $scope.recurrenceSI = {
                    DayType: "Date Wise",
                    Date: 0,
                    DayOn: "Date Wise",
                    Day: "",
                    Interval: 1,
                    FromDate: new Date(),
                    ToDate: new Date(),
                }

                var aYearFromNow = new Date();
                aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);

                $scope.recurrenceSI.ToDate = aYearFromNow;

                $scope.expandView = false;

                $scope.ViewVal = 0;

                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.CurrentCPV = {
                    Date: new Date(),
                    Remarks: "",
                    VoucherNumber: "",
                    SubTotal: 0,
                    TotalTax: 0,
                    GrandTotal: 0,
                    Id: 0,
                    AccountId: "",
                    AccountName: "",
                    CompanyExpenseDetails: [],
                    CompanyExpensePayments: []
                }

                for (var i = 0; i < 5; i++) {

                    var CPVDetails = {
                        Id: 0,
                        AccountId: "",
                        VATId: "",
                        Quantity: 0,
                        Amount: 0,
                        SubTotal: 0,
                        Taxable: 0,
                        TotalTAX: 0,
                        GrandTotal: 0,
                        Description: "",
                        VATType: "Exclusive",
                        Account: {},
                    }

                    $scope.CurrentCPV.CompanyExpenseDetails.push(CPVDetails);
                }

                $scope.ErrorText = "";
                $scope.Load = false;

                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Company Expense").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentCPV.BaseCurrencyId = $scope.CompanyProfile.BaseCurrencyId;

                        MainService.VoucherAccountsInVoucher("Company Expense").then(function (res) {
                            $scope.CurrentCPV.Account = res.data.CreditAccount;
                            $scope.CurrentCPV.AccountId = res.data.CreditAccountId;
                        }, function (err) {
                            toastr.error($scope.LanguageData.NetworkErrorWhileLoadingAccountSettings);
                        })

                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Company Expense").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                    })
                    MainService.GetNextCompanyExpenseNo().then(function (response) {
                        $scope.CurrentCPV.VoucherNumber = response.data;
                    });
                }

                setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);
            }
            $scope.Init();

            $scope.getFlats = function (row) {
                $scope.Load = true;

                MainService.FlatsByBuildingId(row.BuildingId).then(function (response) {
                    row.Flats = response.data;
                    $scope.Load = false;

                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }

            $scope.PaidFromAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Company Expense";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.PaidFromAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.AccountId = data.Id;
                    $scope.CurrentCPV.AccountName = data.Name;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.PaidFromAutocompleteDataSource
            };

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Company Expense";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: " ",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.SelectedCE.VATId = $scope.CompanyProfile.DefaultVATId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.SelectedCE.VATId = $scope.CompanyProfile.DefaultVATId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;
                data.SubTotal = data.Amount * data.Quantity;
                data.Taxable = data.Amount * data.Quantity;
                $scope.CurrentCPV.SubTotal = 0;
                $scope.CurrentCPV.TotalTax = 0;
                $scope.CurrentCPV.GrandTotal = 0;

                data.taxval = 0;
                angular.forEach($scope.VATs, function (e) {
                    if (e.Id == data.VATId) {
                        data.taxval = e.Value;
                    }
                });

                if (data.VATType == "Inclusive") {
                    data.TotalTAX = (data.SubTotal * data.taxval) / (100 + data.taxval);
                    data.TotalTAX = Math.round(data.TotalTAX * 1000) / 1000;
                    data.Taxable = data.Taxable - data.TotalTAX;
                    data.Taxable = Math.round(data.Taxable * 1000) / 1000;
                } else {
                    data.TotalTAX = data.SubTotal * (data.taxval / 100);
                    data.TotalTAX = Math.round(data.TotalTAX * 100) / 100;
                }

                data.GrandTotal = data.TotalTAX + data.Taxable;

                angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {

                    $scope.CurrentCPV.SubTotal = $scope.CurrentCPV.SubTotal + e.Taxable;
                    $scope.CurrentCPV.TotalTax = $scope.CurrentCPV.TotalTax + e.TotalTAX;

                });

                $scope.CurrentCPV.GrandTotal = $scope.CurrentCPV.SubTotal + $scope.CurrentCPV.TotalTax;

                var a = $scope.CurrentCPV.CompanyExpenseDetails.indexOf(data);

                if (($scope.CurrentCPV.CompanyExpenseDetails.length - 1) == a) {
                    var CPVDetails = {
                        Id: 0,
                        AccountId: "",
                        VATId: "",
                        Quantity: 0,
                        Amount: 0,
                        SubTotal: 0,
                        Taxable: 0,
                        TotalTAX: 0,
                        GrandTotal: 0,
                        Description: "",
                        VATType: "Exclusive",
                        Account: {},
                        CostCenters: angular.copy($scope.CostCenters),

                    }

                    $scope.CurrentCPV.CompanyExpenseDetails.push(CPVDetails);
                }
            }


            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }
                //                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentCPV.Id > 0) {
                //                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                //                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentCPV.Id > 0) {
                //                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                //
                //                }
                $scope.ErrorText = "";

                $scope.CurrentCPV.DateString = $scope.extractDate($scope.CurrentCPV.Date);
                if ($scope.CurrentCPV.Field16 != null) {
                    $scope.CurrentCPV.F16DateString = $scope.extractDate($scope.CurrentCPV.Field16);
                }
                if ($scope.CurrentCPV.Field17 != null) {
                    $scope.CurrentCPV.F17DateString = $scope.extractDate($scope.CurrentCPV.Field17);
                }
                if ($scope.CurrentCPV.Field18 != null) {
                    $scope.CurrentCPV.F18DateString = $scope.extractDate($scope.CurrentCPV.Field18);
                }
                if ($scope.CurrentCPV.Field19 != null) {
                    $scope.CurrentCPV.F19DateString = $scope.extractDate($scope.CurrentCPV.Field19);
                }
                if ($scope.CurrentCPV.Field20 != null) {
                    $scope.CurrentCPV.F20DateString = $scope.extractDate($scope.CurrentCPV.Field20);
                }


                var count = 0;
                var count2 = 0;
                var costval = 0;
                angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {


                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }


                    if ((e.AccountId > 0 && e.GrandTotal <= 0) || (e.AccountId == "" && e.GrandTotal > 0)) {
                        count = count + 1;
                    } else if (e.AccountId > 0 && e.GrandTotal > 0) {
                        count2 = count2 + 1;
                    }

                    if (e.AccountId > 0 && e.GrandTotal > 0) {
                        e.CompanyExpenseCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.CompanyExpenseCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }
                })

                $scope.CurrentCPV.CompanyExpenseCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.CurrentCPV.CompanyExpenseCosts.push(cst);
                            }
                        }
                    }
                })

                angular.forEach($scope.CurrentCPV.CompanyExpensePayments, function(e){
                    e.DateString =  $scope.extractDate(e.Date);
                })


                if ($scope.CurrentCPV.AccountId == "") {
                    $scope.ErrorText = $scope.LanguageData.SelectAccount;
                } else if (count > 0) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                } else if (count2 == 0) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentCPV.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentCPV.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                } else {
                    if ($scope.ErrorText == "") {
                        $('#saveModal').modal('show');
                    } else {
                        toastr.warning($scope.ErrorText);
                    }
                }


            }

            $scope.SaveWithConfirm = function () {
                $scope.Load = true;
                $scope.CurrentCPV.VoucherDocs = $scope.VoucherDocs;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.addCompanyexpense($scope.CurrentCPV).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Company Expense', $scope.CurrentCPV.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("companyExpense");
                } else {
                    $scope.Init();
                }

            }

            $scope.ViewVouchers = function () {
                if (!$scope.TokenInfo.IsView && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToViewData);
                } else {
                    viewCompanyExpenseFactory.select().then(function (_selectedReceipt) {
                        if (_selectedReceipt != null) {
                            loadViewDatas(_selectedReceipt);
                        }
                    })
                }
            }

            var loadViewDatas = function (_selectedReceipt) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCompanyExpense(_selectedReceipt.Id).then(function (response) {

                    $scope.CurrentCPV = response.data[0];

                    $scope.CurrentCPV.Date = new Date($scope.CurrentCPV.Date);
                    $scope.CurrentCPV.AccountName = $scope.CurrentCPV.Account.Name;

                    angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {
                        if (e.BuildingId > 0) {
                            $scope.getFlats(e);
                        }
                        if (e.VehicleCategoryId > 0) {
                            $scope.getVehicles(e);
                        }
                    })

                    if ($scope.CurrentCPV.CompanyExpenseDetails.length <= 5) {

                        var temp2 = 5 - $scope.CurrentCPV.CompanyExpenseDetails.length;

                        if (temp2 > 0) {
                            for (var i = 0; i < temp2; i++) {

                                var CPVDetails = {
                                    Id: 0,
                                    AccountId: "",
                                    VATId: "",
                                    Quantity: 0,
                                    Amount: 0,
                                    SubTotal: 0,
                                    Taxable: 0,
                                    TotalTAX: 0,
                                    GrandTotal: 0,
                                    GrandTotal: 0,
                                    Description: "",
                                    Account: {},
                                    VATType: "Exclusive",
                                    CostCenters: angular.copy($scope.CostCenters),

                                }

                                $scope.CurrentCPV.CompanyExpenseDetails.push(CPVDetails);
                            }
                        }

                    }


                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            };

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    if ($scope.CurrentCPV.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }


            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCompanyExpense($scope.CurrentCPV.Id).then(function (response) {
                    toastr.success("Deleted");
                    $scope.Load = false;
                    $('#deleteModal').modal('hide');
                    $state.go("companyExpense");
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                })
            }

            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {

                var CPVDetails = {
                    Id: 0,
                    AccountId: "",
                    VATId: "",
                    Quantity: 0,
                    Amount: 0,
                    SubTotal: 0,
                    TotalTAX: 0,
                    GrandTotal: 0,
                    Taxable: 0,
                    Description: "",
                    VATType: "Exclusive",
                    Account: {},
                    CostCenters: angular.copy($scope.CostCenters),

                }


                $scope.CurrentCPV.CompanyExpenseDetails.push(CPVDetails);

            }

            $scope.deleteRow = function () {
                var index = $scope.CurrentCPV.CompanyExpenseDetails.indexOf($scope.ClickedRow);
                $scope.CurrentCPV.CompanyExpenseDetails.splice(index, 1);
                $scope.CurrentCPV.Total = 0;
                angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (e) {
                    $scope.CurrentCPV.Total = $scope.CurrentCPV.Total + e.Amount;

                });
            }


            $scope.GetBackCompanyExpense = function (type) {
                var temp = 0;
                if ($scope.CurrentCPV.Id > 0) {
                    temp = $scope.CurrentCPV.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackCompanyExpense(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentCPV.CompanyExpenseDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };


            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };





        }])
